import React, { useState, useEffect } from 'react';
import { useTransition, animated } from 'react-spring'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import react from '../Assets/logo.svg';
import flutter from '../Assets/flutter.png';
import iphone from '../Assets/app.svg';
import android from '../Assets/androidLogo.svg';
import rails from '../Assets/rails.png';


const pages = [
    ({ style }) => <animated.div style={{ ...style, background: 'black' }}>
                    Monthly
                    <div class="wordingPayments">
                        A project can be broken down into a monthly term.
                    </div>
                </animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'black' }}>
        Per Feature
                 <div class="wordingPayments">
                        A project can be broken down into features added.
                    </div>
            </animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'black' }}>
            Single Scope
            <div class="wordingPayments">
                A project can be made into a single payment.
            </div>
   
    </animated.div>,
  ]

function Affordable(){
    const [index, set] = useState(0)
    const onClick = useEffect(() => void setInterval(() => set(state => (state + 1) % 3), 7000),  [])
    const transitions = useTransition(index, p => p, {
      from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
      enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
      leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
    })
    return(
        <Row className="spacing differentColor " >

            <Col md={6} data-aos={"fade-up"} className="text-center ">
                <div className="simple-trans-main-pricing spacingSimple" onLoad={onClick} >
                {transitions.map(({ item, props, key }) => {
                    const Page = pages[item]
                    return <Page key={key} style={props} />
                })}
                </div>
            </Col>
            <Col  md={1}></Col>
            <Col md={5} data-aos={"fade-up"} className="text-center heightRegis" style={{marginTop: "25px"}}>
                <div className="titleProcess2">Affordable Pricing</div>
                <div className="textPricing" >
                    You can choose between three different payment plans, making sure that you get the utmost value out of your money. 
                </div>
            </Col>
     



 
        </Row>
    )
}


export default Affordable;